import React from 'react';
import { BarChart, Bar, CartesianGrid, XAxis, YAxis, ReferenceLine, ResponsiveContainer } from 'recharts';


const WaterLevelGauge = ({
  minOnRecord,
  typicalRangeLow,
  typicalRangeHigh,
  maxOnRecord,
  currentValue,
  forecastValue,
  gaugeLabel
}) => {
	
	let absolutes = {
		name: gaugeLabel || "Measurement",
		// "Maximum on Record": maxOnRecord,
		// "Typical Maximum": typicalRangeHigh,
		// "Typical Minimum": typicalRangeLow < 0 ? 0 : typicalRangeLow,
		// "Minimum on Record": minOnRecord < 0 ? null : minOnRecord,
		"Current Value": currentValue
	}
	// // Correct to make these absolute
	// if(minOnRecord > 0) {
	// 	absolutes["Maximum on Record"] = absolutes["Maximum on Record"] - minOnRecord;
	// 	absolutes["Typical Maximum"] = absolutes["Typical Maximum"] - minOnRecord;
	// 	absolutes["Typical Minimum"] = absolutes["Typical Minimum"] - minOnRecord;
	// }
	// if(typicalRangeLow > 0) {
	// 	absolutes["Maximum on Record"] = absolutes["Maximum on Record"] - typicalRangeLow;
	// 	absolutes["Typical Maximum"] = absolutes["Typical Maximum"] - typicalRangeLow;
	// }
	// absolutes["Maximum on Record"] = absolutes["Maximum on Record"] - typicalRangeHigh;

	let runningTotal = 0;

	// Minimum on Record
	if(minOnRecord > 0) {
		absolutes["Minimum on Record"] = parseFloat(minOnRecord);
	} else {
		absolutes["Minimum on Record"] = 0;
	}
	runningTotal = runningTotal + absolutes["Minimum on Record"];

	// Typical Minimum
	if(typicalRangeLow > 0) {
		absolutes["Typical Minimum"] = parseFloat(typicalRangeLow)-runningTotal;
	} else {
		absolutes["Typical Minimum"] = 0;
	}
	runningTotal = runningTotal + absolutes["Typical Minimum"];

	// Typical Maximum
	if(typicalRangeHigh > 0) {
		absolutes["Typical Maximum"] = parseFloat(typicalRangeHigh) - runningTotal;
	} else {
		absolutes["Typical Maximum"] = 0;
	}
	runningTotal = runningTotal + absolutes["Typical Maximum"];

	// Maximum on Record
	if(maxOnRecord > 0) {
		absolutes["Maximum on Record"] = parseFloat(maxOnRecord) - runningTotal;
	} else {
		absolutes["Maximum on Record"] = 0;
	}
	runningTotal = runningTotal + absolutes["Maximum on Record"];

	let domain = ["auto", "auto"];
	let isBrokenAxis = false;
	if((parseFloat(minOnRecord) > 25 || parseFloat(typicalRangeLow) > 25) && parseFloat(currentValue) > typicalRangeLow) {
		domain = [typicalRangeLow*0.93, 'auto'];
		isBrokenAxis = true;
	}
	
	let barData = [absolutes];

	  return <ResponsiveContainer width="100%" height="100%">
		  <BarChart data={barData} width="100" height="100">
		  	<XAxis dataKey="name" />
		    <YAxis domain={domain} allowDataOverflow />
		    <Bar dataKey="Minimum on Record" fill="#8B4513" stackId="a" />
		    <Bar dataKey="Typical Minimum" fill="#d7c0a2" stackId="a" />
		    <Bar dataKey="Typical Maximum" fill="#C1E1C1" stackId="a" />
		    <Bar dataKey="Maximum on Record" fill="#ff6961" stackId="a" />
		    <Bar dataKey="Current Value" fill="#A7C7E7" stackId="b" />
		   	<CartesianGrid />

		   {/*<ReferenceLine y={typicalRangeHigh} label={null} stroke={"black"} strokeDasharray="3 3" />
		   <ReferenceLine y={typicalRangeLow} label={null} stroke={"black"} strokeDasharray="3 3" />*/}
		   <ReferenceLine y={currentValue} label={null} stroke={"blue"} isAnimationActive={false} />
		   {forecastValue && <ReferenceLine y={forecastValue} label={null} stroke={"black"} isAnimationActive={false} strokeDasharray="2 2" />}
		  </BarChart>
	</ResponsiveContainer>;
};
/*
		    
		    <Bar dataKey="Maximum on Record" fill="#FF5733" stackId="a">
		      <LabelList dataKey="Maximum on Record" position="insideTop" />
		    </Bar>
		    <Bar dataKey="Maximum on Record" fill="#FF2500" stackId="a">
		      <LabelList dataKey="Maximum on Record" position="insideTop" />
		    </Bar>*/

export default WaterLevelGauge;

// const WaterLevelGauge = ({
//   minOnRecord,
//   typicalRangeLow,
//   typicalRangeHigh,
//   maxOnRecord,
//   currentValue
// }) => {
//   // Calculate the gauge value (between 0 and 1)
//   const gaugeValue = (currentValue - minOnRecord) / (maxOnRecord - minOnRecord);

//   // Define color ranges for the gauge
//   const colors = ['#8B4513', '#008000', '#FFA500']; // brown, green, orange

//   // Calculate the arc percentage for each range
//   const arcRanges = [
//     (typicalRangeLow - minOnRecord) / (maxOnRecord - minOnRecord),
//     (typicalRangeHigh - typicalRangeLow) / (maxOnRecord - minOnRecord),
//     1
//   ];

//   return (
//     <GaugeChart
//       id="water-level-gauge"
//       nrOfLevels={3}
//       colors={colors}
//       arcWidth={0.3}
//       percent={gaugeValue}
//       arcsLength={arcRanges}
//       hideText={true}
//       textColor={"black"}
//       labels={["Min on record", "Normal Minimum", "Normal Maximum", "Maximum on Record"]}
//     />
//   );
// };

// export default WaterLevelGauge;


/*import React from 'react';
import GaugeComponent from 'react-gauge-component'

const WaterLevelGauge = ({
  minOnRecord,
  typicalRangeLow,
  typicalRangeHigh,
  maxOnRecord,
  currentValue
}) => {
  // Calculate the gauge value (between 0 and 1)
  const gaugeValue = (currentValue - minOnRecord) / (maxOnRecord - minOnRecord);

  // Define color ranges for the gauge
  const colors = ['#8B4513', '#008000', '#FFA500']; // brown, green, orange

  // Calculate the arc percentage for each range
  const arcRanges = [
    (typicalRangeLow - minOnRecord) / (maxOnRecord - minOnRecord),
    (typicalRangeHigh - typicalRangeLow) / (maxOnRecord - minOnRecord),
    1
  ];

  return (
    <GaugeComponent
    	value={currentValue}
    	maxValue={maxOnRecord}
    	minValue={minOnRecord}
		arc={{
			colorArray: ['#8B4513', '#8B4513', '#008000', '#FF2525'],
			subArcs: [
				{limit: minOnRecord, showTick: false},
				{limit: typicalRangeLow, showTick: true},
				{limit: typicalRangeHigh, showTick: true},
				{limit: maxOnRecord, showTick: false}
			],
			padding: 0.02,
			width: 0.3
		}}
		style={{height: "170px"}}
    />
  );
};

export default WaterLevelGauge;
*/
